module.exports = __webpack_public_path__ + "img/cityRestSunshine.87066810.jpg";